module.exports = __webpack_public_path__ + "static/media/progresspending.c2f14a0a.svg";